import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
}

export function GenericErrorToast(props: Props) {
  const { id } = props
  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="error"
      body={polyglot.t("error_messaging.generic_error")}
      id={id}
    />
  )
}
